import React from "react"
import SupportAgentIcon from "@mui/icons-material/SupportAgent"
import {Box} from "@mui/material"
import DashboardOutlinedIcon from "@mui/icons-material/DashboardOutlined"
import PersonOutlinedIcon from "@mui/icons-material/PersonOutlined"
import EventNoteIcon from "@mui/icons-material/EventNote"
import InsightsIcon from "@mui/icons-material/Insights"
import GroupsIcon from "@mui/icons-material/Groups"
import BoltIcon from "@mui/icons-material/Bolt"
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong"
import WidgetsIcon from "@mui/icons-material/Widgets"
import ArchiveIcon from "@mui/icons-material/Archive"
import SyncProblemIcon from "@mui/icons-material/SyncProblem"
import SearchIcon from "@mui/icons-material/Search"
import QueryStatsIcon from "@mui/icons-material/QueryStats"
import BadgeIcon from "@mui/icons-material/Badge"
import TuneIcon from "@mui/icons-material/Tune"
import VerifiedUserIcon from "@mui/icons-material/VerifiedUser"
import ArticleIcon from "@mui/icons-material/Article"
import PrivacyTipIcon from "@mui/icons-material/PrivacyTip"
import ForumOutlinedIcon from "@mui/icons-material/ForumOutlined"
import FlagIcon from "@mui/icons-material/Flag"
import CircleOutlinedIcon from "@mui/icons-material/CircleOutlined"

const AssistantIcon = (
    <Box component="span" role="img" aria-label="Assistant" sx={{fontSize: 20, lineHeight: 1}}>🤖</Box>
)

// Single source of truth: the same menu title gets the same icon in every game.
const ICONS = {
    "Assistant": AssistantIcon,
    "Dashboard": <DashboardOutlinedIcon/>,
    "User State": <PersonOutlinedIcon/>,
    "UserStates": <PersonOutlinedIcon/>,
    "Player Events": <EventNoteIcon/>,
    "Analytics": <InsightsIcon/>,
    "Clans": <GroupsIcon/>,
    "Export Chat": <ForumOutlinedIcon/>,
    "Charger": <BoltIcon/>,
    "ChargerLogs": <ReceiptLongIcon/>,
    "Prefabs": <WidgetsIcon/>,
    "Archive": <ArchiveIcon/>,
    "Sync Conflicts": <SyncProblemIcon/>,
    "Search": <SearchIcon/>,
    "Analytical Search": <QueryStatsIcon/>,
    "Flagged Players": <FlagIcon/>,
    "Mephisto Profile": <BadgeIcon/>,
    "Charge Management": <TuneIcon/>,
    "White list management": <VerifiedUserIcon/>,
    "Article Exporter": <ArticleIcon/>,
    "GDPR": <PrivacyTipIcon/>,
    "Zendesk": <SupportAgentIcon/>
}

export default function menuIcon(title) {
    return ICONS[title] ?? <CircleOutlinedIcon/>
}
